import { render } from "./ImportValueList.vue?vue&type=template&id=88dae69a"
import script from "./ImportValueList.vue?vue&type=script&lang=js"
export * from "./ImportValueList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__